/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import PositionedGraphBackground from "../Intro/GraphBackground/sizedIndex";
import ContactModal from "../ContactSales";
import { Analytics } from "../../api/analytics";
import { lazy, Suspense } from "react";
import "./index.css";
import FAQ from "../Intro/Help";


const Resources = lazy(() => import("../Intro/Resources"));
const Demo = lazy(() => import("../Intro/Demo"));
const TeamBio = lazy(() => import("../Intro/TeamBio"));


const GlueLogo = ({ width = 160 }) => (
    <img src="/images/logo.svg" alt="Glue Logo" className="logo-img" width={width} height="auto" />
);

export default function AdminDashboard() {
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);
    const [teamBio, setTeamBio] = useState({
        header: "Meet the team",
        members: []
    });

    const [faqData, setFaqData] = useState([
        {
            question: "What is GlueID?",
            answer:
                "GlueID is an interactive graph visualization tool."
        }
    ]);

    const [pageDetails, setPageDetails] = useState({

        header: "What Our Platform Provides",

        featuresData: {

            features: [
                "Improved counterparty risk assessment",
                "Stronger AML regulatory compliance",
            ],

            identifiers: [
                "UEI",
                "CUSIP",
            ]
        }
    });

    const [isSaving, setIsSaving] = useState(false);
    const [demo, setDemoData] = useState({
        eyebrow: "GRAPH FIRST SEARCH ENGINE",
        title: "Explore the story behind your data.",
        description: "From tangled data to clear context...",
        linkText: "Explore more →",
        poster: "/poster.png",
        video: "/video.mp4"
    });

    // Editable Hero Content
    const [heroData, setHeroData] = useState({
        title: "Turn Complex Data into Clear Decisions \n Discover Hidden Patterns",
        subtitle: "Explore hidden relationships in your data with interactive graph visualization",
        // New button fields
        primaryBtnText: "Get started",
        primaryBtnLink: "/signup",
        outlineBtnText: "Explore Tool",
        outlineBtnLink: "#demo"
    });

    const [footerData, setFooterData] = useState({
        copyright: "© 2009-2026 Partners Inc. All Rights Reserved",
        linkedin: "https://www.linkedin.com/company/noeticpartners",
        email: "contact@company.com"
    });

    const handleSave = async () => {
        const bigPayload = {
            payload: [
                { sectionId: "hero", data: heroData },
                { sectionId: "pageDetails", data: pageDetails },
                { sectionId: "teamBio", data: teamBio },
                { sectionId: "demo", data: demo },
                { sectionId: "faq", data: faqData },
                { sectionId: "footer", data: footerData }
            ]
        };

        setIsSaving(true);

        try {
            const res = await fetch(
                "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(bigPayload)
                }
            );

            const data = await res.json();

            console.log("📥 RAW SAVE RESPONSE:", data);

            // ✅ Handle API Gateway wrapped response
            const body = typeof data.body === "string"
                ? JSON.parse(data.body)
                : data;

            setIsSaving(false);
            console.log("✅ PARSED SAVE RESPONSE:", body);

            if (!res.ok) {
                throw new Error(body.error || "Save failed");
            }

            if (body.message === "Saved successfully" || body.message === "Success") {
                setIsEditing(false);
            } else {
                throw new Error("Unexpected response from server");
            }

        } catch (err) {
            console.error("❌ SAVE ERROR:", err);
            alert("❌ Save failed: " + err.message);
        }
    };

    const uploadImage = async (file, type = "image") => {

        // ✅ VIDEO → DIRECT S3 (NO BASE64)
        if (type === "video") {
            try {
                const res = await fetch(
                    "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com",
                    {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            action: "getUploadUrl",
                            fileType: "video"
                        })
                    }
                );

                const { uploadUrl, fileKey } = await res.json();

                await fetch(uploadUrl, {
                    method: "PUT",
                    body: file,
                    headers: {
                        "Content-Type": file.type || "video/mp4"
                    }
                });

                // ✅ REAL S3 URL
                const fileUrl = `https://glue-team-profile.s3.us-east-2.amazonaws.com/${fileKey}`;

                return {
                    key: fileKey,
                    url: fileUrl
                };

            } catch (err) {
                console.error("❌ Video upload failed:", err);
                throw err;
            }
        }

        // ✅ IMAGE → KEEP OLD LOGIC
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
            reader.onload = async () => {
                try {
                    const base64 = reader.result.split(",")[1];

                    const res = await fetch(
                        "https://5549ucvkb3.execute-api.us-east-2.amazonaws.com",
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                file: base64,
                                fileType: "image"
                            })
                        }
                    );

                    const data = await res.json();

                    resolve({
                        key: data.fileKey,
                        url: data.fileUrl
                    });

                } catch (err) {
                    reject(err);
                }
            };

            reader.readAsDataURL(file);
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            debugger
            try {
                const res = await fetch("https://5549ucvkb3.execute-api.us-east-2.amazonaws.com");
                const data = await res.json();

                const body = typeof data.body === 'string' ? JSON.parse(data.body) : data;

                if (body.hero) setHeroData(body.hero);
                if (body.faq) {

                    setFaqData(
                        Array.isArray(body.faq)
                            ? body.faq
                            : []
                    );
                }
                if (body.pageDetails) {

                    setPageDetails({

                        header:
                            body.pageDetails.header?.trim()
                            || "What Our Platform Provides",

                        featuresData: {

                            features:
                                body.pageDetails
                                    ?.featuresData
                                    ?.features || [],

                            identifiers:
                                body.pageDetails
                                    ?.featuresData
                                    ?.identifiers || []
                        }
                    });

                } else {

                    setPageDetails({

                        header:
                            "What Our Platform Provides",

                        featuresData: {

                            features: [
                                "Improved counterparty risk assessment",
                                "Stronger AML regulatory compliance",
                            ],

                            identifiers: [
                                "UEI",
                                "CUSIP",
                            ]
                        }
                    });
                }
                if (body.demo) setDemoData(body.demo);
                if (body.teamBio) {
                    const safeMembers = Array.isArray(body.teamBio.members)
                        ? body.teamBio.members
                        : Array.isArray(body.teamBio)
                            ? body.teamBio
                            : [];

                    setTeamBio({
                        header: body.teamBio.header || "Meet the team",
                        members: safeMembers
                    });
                } else {
                    setTeamBio({
                        header: "Meet the team",
                        members: []
                    });
                }
                if (body.footer) setFooterData(body.footer);

            } catch (err) {
                console.error("Error fetching:", err);
                setPageDetails({
                    header: "What Our Platform Provides",
                    benefits: []
                });
            } finally {
                setLoading(false); // ✅ IMPORTANT
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <div className="landing-container">
                <section className="hero">
                    <div className="skeleton-container">
                        <div className="skeleton skeleton-title" />
                        <div className="skeleton skeleton-subtitle" />
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className={`landing-container ${isEditing ? "mode-editing" : ""}`}>
            {/* Navbar */}

            {isSaving && (
                <div className="global-loader">
                    <div className="loader-box">
                        <div className="spinner" />
                        <p>Saving changes...</p>
                    </div>
                </div>
            )}
            <header className="navbar">
                <div className="navbar-links">
                    <div className="logo">
                        <Link to="/" style={{ textDecoration: "none" }}><GlueLogo /></Link>
                    </div>
                    <nav className="nav-links">
                        <a href="#demo">Demo</a>
                        <a href="#team">Team</a>
                        <Link to="/help" className="login" style={{ textDecoration: "none" }}>
                            Help
                        </Link>
                        <Link
                            to="/sales"
                            className="login"
                            style={{ textDecoration: "none" }}
                        >
                            Pricing
                        </Link>
                    </nav>
                </div>

                <div className="actions">
                    {isEditing ? (
                        <button className="btn-save-top" onClick={handleSave}>Save Changes</button>
                    ) : (
                        <button className="btn-edit-toggle" onClick={() => setIsEditing(true)}>Edit Page</button>
                    )}
                    <Link
                        to="/"
                        className="login"
                        style={{ textDecoration: "none" }}
                        onClick={() => Analytics.loginAttempt("email")}
                    >
                        Login
                    </Link>
                    <ContactModal triggerClass="btn-outline" />
                </div>
            </header>

            {/* Hero Section */}
            <section className="hero">
                <PositionedGraphBackground />

                {isEditing ? (
                    <div className="edit-container">
                        {/* Title & Subtitle Edits */}
                        <textarea
                            className="edit-input hero-title-edit"
                            value={heroData.title}
                            onChange={(e) => setHeroData({ ...heroData, title: e.target.value })}
                        />
                        <textarea
                            className="edit-input hero-subtitle-edit"
                            value={heroData.subtitle}
                            onChange={(e) => setHeroData({ ...heroData, subtitle: e.target.value })}
                        />
                    </div>
                ) : (
                    <>
                        <h1 className="hero-title">{heroData.title}</h1>
                        <p className="hero-subtitle">{heroData.subtitle}</p>
                    </>
                )}
            </section>

            {/* Sections */}
            <Suspense fallback={<div style={{ height: "200px" }} />}>
                <section id="resources">
                    <Resources
                        pageDetails={pageDetails}
                        isEditing={isEditing}
                        onChange={(updatedData) => setPageDetails(updatedData)}
                    />
                </section>
            </Suspense>

            <Suspense fallback={<div style={{ height: "200px" }} />}>
                <section id="demo">
                    <Demo
                        uploadImage={uploadImage}
                        isEditing={isEditing}
                        demoData={demo}
                        onChange={setDemoData}
                    />
                </section>
            </Suspense>

            <Suspense fallback={<div style={{ height: "200px" }} />}>
                <section id="team">
                    <TeamBio
                        members={Array.isArray(teamBio.members) ? teamBio.members : []}
                        header={teamBio.header}
                        isEditing={isEditing}
                        onChange={(updatedData) => setTeamBio(updatedData)}   // ✅ IMPORTANT
                        uploadImage={uploadImage}
                    />
                </section>
            </Suspense>

            {isEditing ? (

                <FAQ
                    enable_faq_editing={true}
                    headerFalse={true}
                    faqData={faqData}
                    onChange={setFaqData}
                />

            ) : (

                <FAQ
                    headerFalse={true}
                    faqData={faqData}
                />
            )}

            {/* Footer Section */}
            {<div className="edit-container">{isEditing ? <h2>Edit Footer</h2> : <h2> Footer Section</h2>}</div>}
            <section className="footer-section" style={{ padding: "40px", textAlign: "center" }}>
                {isEditing ? (
                    <div className="edit-container-footer">
                        <div className="edit-footer-div">
                            <label>Copyright Text</label>
                            <textarea
                                className="edit-input"
                                value={footerData.copyright}
                                onChange={(e) =>
                                    setFooterData({ ...footerData, copyright: e.target.value })
                                }
                                placeholder="Copyright Text"
                            />
                        </div>
                        <div>
                            <label>Linkedin URL</label>
                            <input
                                className="edit-input"
                                value={footerData.linkedin}
                                onChange={(e) =>
                                    setFooterData({ ...footerData, linkedin: e.target.value })
                                }
                                placeholder="LinkedIn URL"
                            />
                        </div>
                        <div>
                            <label>Company Email</label>
                            <input
                                className="edit-input"
                                value={footerData.email}
                                onChange={(e) =>
                                    setFooterData({ ...footerData, email: e.target.value })
                                }
                                placeholder="Email Address"
                            />
                        </div>
                    </div>
                ) : (
                    <div>
                        <p>{footerData.copyright}</p>

                        <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                            <a href={footerData.linkedin} target="_blank" rel="noreferrer">
                                LinkedIn
                            </a>
                            <a href={`mailto:${footerData.email}`}>
                                {footerData.email}
                            </a>
                        </div>
                    </div>
                )}
            </section>

            {/* Bottom Save Bar */}
            {isEditing && (
                <div className="save-bar-bottom">
                    <p>You have unsaved changes</p>
                    <div className="save-bar-actions">
                        <button className="btn-outline" onClick={() => setIsEditing(false)}>Cancel</button>
                        <button className="btn-primary" onClick={handleSave} disabled={isSaving}>
                            {isSaving ? "Saving..." : "Save All Changes"}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}